import { Component, Input } from "@angular/core";
import { StepStateEnum, WorkflowStepConfig } from "../models/workflow-step-config";
import { CommonModule } from "@angular/common";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "eff-workflow-popover",
    templateUrl: "./eff-workflow-popover.component.html",
    styleUrls: ["./eff-workflow-popover.component.scss"],
    imports: [CommonModule, TranslocoPipe]
})
export class EffWorkflowPopoverComponent {
    @Input() step: WorkflowStepConfig;
    stepStateEnum = StepStateEnum;
}
